<template>
  <div class="newalarm" :class="{disable:disabled}">
    <transition-group tag="div" class="enableList  bdSub boxR-light cb tra ml05x_E pb05x mt05x_E fL_E"  v-on:leave="el=>{transitionAction(el,'hide-x');}" :duration="500">
    	  <button v-if="temp.length>0&&!disabled" class="clearTag hover-f-error hover-effect-rotate tra-fast" :key="'clear'" @click="clear" type="button">
    	  	<!--<div class="icoSys w1x h1x bgSub fSub fs16x"><Icon name="no" /></div>--></button>
        <TagBox v-for="(item,index) in temp" :key="item.id" :styleType="'tag'" :val="rs(item.name,item.id)" :data="item" @Remove="onRemove(item.id,index)" :removeButton="disabled?false:true"></TagBox>
        <button :key="'add'" class="lh15 cMain" type="button" @click.stop="showList" v-if="!temp.length">+{{getLanguageStr('word27','报警')}}</button>
		</transition-group>
    <div class="bdSub boxR-light ofH" v-if="isShow"  @mouseleave="showAlermMousePos=false" @mouseenter="showAlermMousePos=true" v-clickoutside="handleClose">
      <div class="ml1x mr1x pt05x pb05x taC inputWrap bdSub-bottom">
      	 <InputText class="w20x dpIB" @AfterClear="afterclear"
      	 	 :fn="getList" 
      	 	 :autocomplete="'off'"
      	 	 :placeholder="getLanguageStr('phrase972','输入报警名称/ID')"
      	 	 :addClass="{bgContent:true}" name="alertName"  
      	 	 :clearBtn="true" ref="searchBox" :searchBtn="true" v-model="searchText">
      	 </InputText>
			</div>
			<div class="posR">
				<Loading v-if="loading"></Loading>
				<div class="h23x-max ofH" v-show="list.length" > 
						<div class="fixedScrollBar scrollY tra-fast table" >						
							<div class="tableSys bdLight-bottom head b cField">
								<div class="w20x">{{getLanguageStr('word1745','类型')}}/ID</div>
								<div>{{getLanguageStr('word75','类型')}}</div>
								<div>{{getLanguageStr('word115','等级')}}</div>
								<div class="w12x">{{getLanguageStr('word1481','影响范围')}}</div>
								<div></div>
							</div>
							<div class="h19x-max tableContent" scroll fillHeight=".tableContent,-.newalarm .tableBatch">
								<table class="table table-4x">
									<tbody>
										<tr v-for="(item,index) in list" :key="index" class="bdLight-bottom_E curP" @click="add(item)">
											<td class="w20x">{{item.name}}/ID {{item.id}}</td>
											<td>{{getTypeText(item.type,'alarmType')}}</td><td>{{getTypeText(item.level,'alarmLevelFilter')}}</td>
											<td class="w12x">{{getTypeText(item.influence,'alarmFilterScope')}}</td>
									  	<td><span v-if="item.isAdd" class="cMain">{{getLanguageStr('word56','已选')}}</span></td>
										</tr>
									</tbody>
								</table>
							</div>
					</div>
				</div>
					<div class="h19x-min taC tableSys vaM_E"  v-show="!list.length">
	          <span v-if="searchFlag&&list.length==0&&searchText!=''">{{$t('word1380',['暂无数据'])}}</span>
					</div>
					<div class="tableBatch bgContent cSub pt1x pb1x"  :class="{disable:!list}" v-show="list.length>0&&searchText!=''">
				  	<Pagination :pagination="pagination" :getList="getList" ref="Pagination" class="ml2x" :dir="'up'"></Pagination>
					</div>
			</div>
			</div>
    </div>
  </div>
</template>
<script>
import * as lib from '@/util/lib.js'
import {getLanguageStr} from '@/util/language.js'
import TagBox from '@/components/common/ui/TagBox.vue'
import InputText from '@/components/common/ui/InputText.vue'
import Loading from '@/components/common/ui/Loading'
import {getAlertBase} from '@/api/manage/message.js'
import Pagination from '@/components/common/ui/Pagination.vue'
import clickoutside from '@/plugins/clickOutSide/index.js'
export default {
  name: 'newAlarm',
  components: {TagBox, InputText, Loading,Pagination},
  directives: { clickoutside },
  props: {
    	initData: {
      		// 是否显示遮罩背景
      		type: Array,
      		default: []
    	},
    	disabled: {
      type: Boolean,
      default: false
    	},
  	},
  data () {
    return {
    	searchText:'',
    	list:[],
    	'orderDirection': this.$route.query.order || 'DESC', // DESC
      'orderProperty': this.$route.query.property || 'id',
      pagination: {},
      temp:[],
      isShow:false,
      alarm:[],
      showAlermMousePos:false,
      loading:false,
      searchFlag:false
    }
  },
  methods: {
    transitionAction: lib.transitionAction,
    getLanguageStr,
    getTypeText: lib.getTypeText,
    rs(n,id){
    	return n+'/ID '+id
    },
     handleClose (e) {
      if (!this.showAlermMousePos) {
        this.isShow = false
      }
      this.searchText=''
     	this.getList();
    },
    afterclear: function () {
    	this.searchText=''
	     this.getList();
	    },
	    showList(){
	    	this.isShow=true;
	    },
	    add(item){
	    	this.addB=false
	    	this.$set(this.temp,0,item)
	      for(let i=0;i<this.list.length;i++){
	       this.list[i].isAdd=false
	      }
	      item.isAdd=!item.isAdd
	      this.$emit('Update', item)
	    },
	    getList(){
	    	this.loading=true
	    	this.$nextTick(()=> {
		    let queryParam = {
		    	  'name':this.searchText,
		        'page':this.pagination.request.page,
		        'size':this.pagination.request.size,
		        'order.direction':this.orderDirection,
		        'order.property':this.orderProperty
		    }
		    getAlertBase(queryParam).then(success => {
		    	 	this.searchFlag=true;
	        	this.list = success.total ? success.data:[]
						this.pagination.total = success.total
			      let {total} = success
						this.pagination = {...this.pagination, ...{total}}
						this.$nextTick(()=> {
							this.loading=false
							lib.setScroll($(this.$el).find('[scroll]'))
					})
		    }, error => {
		        !_.isEmpty(error) && this.$notify(error)
		        this.loading=false
		    })
		    });
	    },
    selectData () {
      this.alarm = this.list.filter(el => el.isAdd)
      this.$emit('Update', this.alarm)
    },
    clear () {
    	this.searchFlag=false
      this.temp = []
      this.addB=true
      this.list.forEach(el => {
        this.$set(el, 'isAdd', false)
      })
    },
    onRemove (id, index) {
    	this.searchFlag=false
    	  this.temp=[]
    	  this.addB=true
       this.selectData()
    }
	},
  mounted () {
  		lib.fillHeight()
  	if(this.initData){
	  	if(this.initData.length>0){
	  		this.$set(this.temp,0,this.initData[0])
	  	}
  	}else{
  		this.temp = []
  	}
  },
}
</script>

<style lang="scss" scoped>
.enableList{padding:{bottom:.5em;};position:relative;
	.clearTag{position:absolute;top:0;right:.5em;}
}
</style>



// WEBPACK FOOTER //
// src/view/manage/message/NewAlarm.vue